<template>
	<div id="about-container">
		<!-- about -->
	<div class="agile-about w3ls-section text-center" id="aboutMe">
		<div class="container">
			<h3 class="agileits-title">about me</h3>
			<div class="agileits-about-grid">
				<p>I am a software engineer at mastercard. I tend to work in teams in collaboration with product and QA to innovate, plan, build and deliver solutions in a timely manner</p>
			</div>
			<a href="#projects" class="wthree- about-link scroll">Projects</a>
		</div>
	</div>
	<!-- //about -->
	<!-- about-bottom -->
	<div class="agileits-about-btm">
		<div class="container">
			<div class="w3-flex">
			<div class="col-md-4 col-sm-4 ab1 agileits-about-grid1">
				<span class="fa fa-briefcase  wthree-title-list" aria-hidden="true"></span>
				<h4 class="agileinfo-head">work experience</h4>
				<h5>Software Engineer</h5>
				<p>Mastercard</p>
				<h5>Software Engineering & Product Intern</h5>
				<p>Mastercard</p>
				<h5>Product Manager Intern</h5>
				<p>AIG</p>
			</div>
			<div class="col-md-4 col-sm-4 ab1 agileits-about-grid2">
				<span class="fa fa-graduation-cap  wthree-title-list" aria-hidden="true"></span>
				<h4 class="agileinfo-head">education</h4>
				<h5>Bachelor of Science, Computer Science</h5>
				<p>Pennsylvania State University</p>
				<h5>Minor, Entrepreneurship & Leadership</h5>
				<p>Pennsylvania State University</p>
			</div>
			<div class="clearfix"></div>
			</div>
		</div>
	</div>
	<!-- //about-bottom -->
	</div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
